export default __webpack_public_path__ + "static/media/Grupo 24@2x.c560d37e.png";